import { useLocation } from 'wouter';
import { trpc } from '../../lib/trpc';
import { useAsync } from '../../lib/useAsync';
import { Loading, ErrorBox, KpiCard, PageTitle } from '../../components/admin/ui';
import { formatBRLCompact, formatPct, formatInt, LEAD_ESTAGIOS, LEAD_ESTAGIO_LABEL, PLANO_LABEL } from '../../lib/format';

export function AdminLeads() {
  const [, navigate] = useLocation();
  const { data, loading, error, reload } = useAsync(() => trpc.admin.leads.query());

  return (
    <div className="mx-auto max-w-6xl">
      <PageTitle titulo="Leads / CRM" />

      {loading && <Loading />}
      {error && <ErrorBox msg={error} onRetry={reload} />}

      {data && (
        <>
          <div className="mb-5 grid grid-cols-2 gap-4 lg:grid-cols-4">
            <KpiCard label="Leads no funil" valor={formatInt(data.leads.filter((l) => !['ganho', 'perdido'].includes(l.estagio)).length)} />
            <KpiCard label="Valor do pipeline" valor={formatBRLCompact(data.resumo.valorPipeline)} destaque sub="MRR potencial em aberto" />
            <KpiCard label="Taxa de conversão" valor={formatPct(data.resumo.taxaConversao)} sub="ganhos / decididos" />
            <KpiCard label="Total de leads" valor={formatInt(data.leads.length)} />
          </div>

          {/* Board por estágio */}
          <div className="grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-6">
            {LEAD_ESTAGIOS.map((estagio) => {
              const doEstagio = data.leads.filter((l) => l.estagio === estagio);
              return (
                <div key={estagio} className="flex flex-col">
                  <div className="mb-2 flex items-center justify-between px-1">
                    <span className="text-xs font-semibold uppercase tracking-wide text-ink-3">
                      {LEAD_ESTAGIO_LABEL[estagio]}
                    </span>
                    <span className="num text-xs text-ink-4">{doEstagio.length}</span>
                  </div>
                  <div className="flex flex-col gap-2">
                    {doEstagio.length === 0 && (
                      <div className="rounded border border-dashed border-line-2 px-3 py-4 text-center text-xs text-ink-4">
                        vazio
                      </div>
                    )}
                    {doEstagio.map((l) => (
                      <button
                        key={l.id}
                        onClick={() => navigate(`/admin/leads/${l.id}`)}
                        className="card p-3 text-left transition-colors hover:bg-bg-warm"
                      >
                        <div className="text-sm font-medium text-ink">{l.nome}</div>
                        <div className="mt-1 flex items-center justify-between">
                          <span className="text-[11px] text-ink-3">
                            {l.planoProvavel ? PLANO_LABEL[l.planoProvavel] : '-'} · {l.porteEstimado} contr.
                          </span>
                          <span className="num text-[11px] font-medium text-accent">
                            {formatBRLCompact(l.mrrPotencial)}
                          </span>
                        </div>
                        {l.proximoPasso && (
                          <div className="mt-1.5 truncate text-[11px] text-ink-4">→ {l.proximoPasso}</div>
                        )}
                      </button>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
